import { selector, atom } from "recoil";
import { getFeature, getBankPage } from "../services/apiCalls";

export const featureRefresh = atom({
  key: "featureRefresh",
  default: ""
})

export const bankRefresh = atom({
  key: "bankRefresh",
  default: ""
})

export const featureAlert = atom({
  key: "featureAlert",
  default: false
})

export const featureResponse = atom({
  key: "featureResponse",
  default: {}
})

export const features = selector({
  key: "features",
  get: async ({ get }) => {
    try {
      const res = get(featureRefresh);
      console.log(res)
      const result = await getFeature();
      return result.data || [];
    } catch (error) {
      console.error(`ERROR: \n${error}`);
      return [];
    }
  }
});

export const bankPage = selector({
  key: "bankPage",
  get: async ({ get }) => {
    try {
      const res = get(bankRefresh);
      console.log(res)
      const result = await getBankPage();
      return result || {};
    } catch (error) {
      console.error(`ERROR: \n${error}`);
      return {};
    }
  }
});